import { QueryKey, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Tag, useCreateTag, useUpdateTag } from "../api-generated";
import Header from "./Header";

type Props = {
  tag?: Tag;
  onClose: () => void;
  tagQueryKey: QueryKey;
};

//TODO: don't like this being both edit and create
const TagForm = ({ tag, tagQueryKey, onClose }: Props) => {
  const [name, setName] = useState(tag?.name || "");
  const createTagMutation = useCreateTag();
  const updateTagMutation = useUpdateTag();
  const qc = useQueryClient();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const newTag = { name };
    const options = {
      onSuccess: () => {
        qc.invalidateQueries(tagQueryKey);
        onClose();
      },
    };
    if (tag) {
      // Editing existing tag
      // Make sure to update the tag ID to the existing tag's ID
      const updatedTag = { ...newTag, id: tag.id };
      updateTagMutation.mutate({ data: updatedTag }, options);
    } else {
      // Creating new tag
      createTagMutation.mutate({ data: newTag }, options);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-sm mx-auto">
      <div className="pb-4">
        <Header type="main" text={tag ? "Edit tag" : "Create tag"} />
      </div>
      <div className="mb-4">
        <label htmlFor="name" className="block mb-2 font-bold text-gray-700">
          Name:
        </label>
        <input
          type="text"
          id="name"
          className="w-full px-3 py-2 leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
          value={name}
          onChange={(event) => setName(event.target.value)}
          autoFocus
          onFocus={(e) => {
            if (tag) {
              e.target.select(); // Highlight all text on focus
            }
          }}
        />
      </div>
      <div className="flex items-center justify-between">
        <button
          type="submit"
          className="px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700 focus:outline-none focus:shadow-outline-blue active:bg-blue-800"
        >
          {tag ? "Save" : "Create"}
        </button>
        {createTagMutation.isLoading && (
          <p className="px-4 py-2 text-gray-700">Creating tag...</p>
        )}
        {createTagMutation.isError && (
          <p className="px-4 py-2 text-red-700">
            Error creating tag: {createTagMutation.error?.message}
          </p>
        )}
        {createTagMutation.isSuccess && (
          <p className="px-4 py-2 text-green-700">Tag created successfully!</p>
        )}

        {updateTagMutation.isLoading && (
          <p className="px-4 py-2 text-gray-700">Updating tag...</p>
        )}
        {updateTagMutation.isError && (
          <p className="px-4 py-2 text-red-700">
            Error updating tag: {updateTagMutation.error?.message}
          </p>
        )}
        {updateTagMutation.isSuccess && (
          <p className="px-4 py-2 text-green-700">Tag updated successfully!</p>
        )}
      </div>
    </form>
  );
};

export default TagForm;
